import React, { useState } from "react";
import "./VisitTagsImages.css";
import { useTagDownloader } from "./ImageDownloadHandler";

export default function VisitTagsImages({ visits }) {
  const [selectedTag, setSelectedTag] = useState(1);
  const [showMoreTags, setShowMoreTags] = useState(false);

  const { handleDownloadTag, isDownloading } = useTagDownloader();

  const visitTagsList = visits?.tags || [];

  const visitTags = visitTagsList.map((tag, index) => ({
    id: index + 1,
    name: tag.tag,

    // Keep complete photo object instead of only photoUrl
    images:
      tag.photos?.map((photo) => ({
        id: photo.id,
        url: photo.photoUrl,
        latitude: photo.latitude,
        longitude: photo.longitude,
      })) || [],
  }));

  if (!visitTags.length) {
    return null;
  }

  const visibleTags = selectedTag
    ? visitTags.filter((item) => item.id === selectedTag)
    : visitTags.slice(0, 1);

  return (
    <div className="visit-tags-section">
      <div className="visit-section-header">
        <div className="visit-section-title">
          <span>Tags</span>
        </div>
      </div>

      <div className="visit-tags-list">
        {(showMoreTags
          ? visitTags
          : visitTags.slice(0, 4)
        ).map((tag) => (
          <button
            key={tag.id}
            className={`visit-tag-btn ${
              selectedTag === tag.id ? "active" : ""
            }`}
            onClick={() => {
              setSelectedTag(tag.id);
            }}
          >
            {tag.name}
          </button>
        ))}

        {!showMoreTags && visitTags.length > 4 && (
          <button
            className="visit-tag-btn more"
            onClick={() => {
              setShowMoreTags(true);
            }}
          >
            +{visitTags.length - 4} More
          </button>
        )}
      </div>

      <div className="visit-photos-heading">
        <div className="visit-photo-title">
          <span className="visit-photo-icon mr-1">▧</span>
          <span>Photos</span>
        </div>
      </div>

      <div className="visit-images-container">
        {visibleTags.map((tag) => (
          <div className="visit-tag-group" key={tag.id}>
            <div className="visit-tag-group-title">
              <div className="visit-tag-name d-flex align-items-center">
                <span className="tag-line"></span>
                <span>{tag.name}</span>
              </div>

              <button
                className="visit-download-btn"
                disabled={isDownloading}
                onClick={() => handleDownloadTag(tag)}
              >
                {isDownloading ? "Processing..." : "Download"}
              </button>
            </div>

            <div className="visit-image-grid">
              {tag.images?.map((image, index) => (
                <div className="visit-image-wrappe" key={image.id || index}>
                  <div className="visit-image-wrapper">
                    <img
                      src={image.url}
                      alt={`${tag.name} ${index + 1}`}
                    />
                  </div>

                  <span className="visit-image-label">
                    {index === 0
                      ? "Top View"
                      : index === 1
                      ? "Side View (0°)"
                      : "Side View (180°)"}
                  </span>

                  {/* Latitude / Longitude */}
                  <div className="visit-image-location font-size-sm font-weight-bold">
                    <div className="location-item">
                      <span className="location-label">
                        Latitude : 
                      </span>
                      <span className="location-value">
                        {image.latitude ?? "-"}
                      </span>
                    </div>

                    <div className="location-item">
                      <span className="location-label">
                        Longitude : 
                      </span>
                      <span className="location-value">
                        {image.longitude ?? "-"}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="visit-images-footer">
        <div className="visit-footer-info">
          <span className="footer-icon">▧</span>

          <div>
            <strong>
              {visitTags.reduce(
                (total, tag) => total + (tag.images?.length || 0),
                0
              )}
            </strong>
            <span> Images</span>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="visit-footer-info">
          <strong>{visitTags.length}</strong>
          <span> Tags</span>
        </div>
      </div>
    </div>
  );
}